// Telemetry to our own server (POST /api/t, text/plain JSON — JSON beacons die cross-origin, Wobble's lesson). What it
// answers: does the first minute land (load → first gameplay → first call → first grab/stash), how long sessions run,
// which device, and every uncaught error. Never personal data: the profile id is a random string, no names, no IPs here.

import { HTTP_BASE } from "./endpoint";

declare const __TNT_BUILD__: string | undefined;
export const BUILD = typeof __TNT_BUILD__ !== "undefined" ? __TNT_BUILD__ : "dev";   // esbuild --define stamps it
const sid = Math.random().toString(36).slice(2, 10);
const t0 = performance.now();
let pid = "", plat = "web", sent = 0;
const q: any[] = [];

export function setIdentity(p: string, platform: string) { pid = p; plat = platform; }
export function ev(k: string, data: Record<string, unknown> = {}) {
  if (sent > 400) return;                       // a runaway loop can never flood the server
  q.push({ k, t: Math.round(performance.now() - t0), sid, pid, plat, build: BUILD, ...data });
  if (q.length >= 12) flush();
}
export function flush(beacon = false) {
  if (!q.length || !HTTP_BASE) return;
  const body = JSON.stringify(q.splice(0, q.length)); sent++;
  const url = HTTP_BASE + "/api/t";
  try {
    if (beacon && navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }));
    else fetch(url, { method: "POST", body, headers: { "Content-Type": "text/plain" }, keepalive: true }).catch(() => {});
  } catch {}
}
setInterval(() => flush(), 15000);
addEventListener("pagehide", () => { ev("leave", { sessionSec: Math.round((performance.now() - t0) / 1000) }); flush(true); });
let errs = 0;
addEventListener("error", (e) => { if (errs++ < 8) ev("error", { msg: String(e.message).slice(0, 300), src: `${e.filename}:${e.lineno}` }); });
addEventListener("unhandledrejection", (e) => { if (errs++ < 8) ev("error", { msg: String((e.reason && e.reason.message) || e.reason).slice(0, 300), kind: "rejection" }); });
export function device() {
  return { w: innerWidth, h: innerHeight, dpr: devicePixelRatio, touch: matchMedia("(pointer: coarse)").matches, mem: (navigator as any).deviceMemory, cores: navigator.hardwareConcurrency };
}
